import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MenuGroup } from '../../models/menu-item.model';
import { VerticalMenuGroupComponent } from '../vertical-menu-group/vertical-menu-group.component';

@Component({
  selector: 'app-vertical-menu',
  imports: [VerticalMenuGroupComponent],
  templateUrl: './vertical-menu.component.html',
  styleUrl: './vertical-menu.component.scss'
})
export class VerticalMenuComponent implements OnChanges {
  @Input({ required: true }) title = 'Menu';
  @Input({ required: true }) groups: MenuGroup[] = [];
  @Input() activePath = '';

  protected expandedIndex = 0;

  protected toggleGroup(index: number): void {
    this.expandedIndex = this.expandedIndex === index ? -1 : index;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const groupsChanged = Boolean(changes['groups']);
    const activePathChanged = Boolean(changes['activePath']);

    if (!groupsChanged && !activePathChanged) {
      return;
    }

    // Quand seul l'objet groups change de référence, on conserve le choix utilisateur.
    if (groupsChanged && !activePathChanged) {
      if (this.expandedIndex >= this.groups.length) {
        this.expandedIndex = this.groups.length > 0 ? 0 : -1;
      }
      return;
    }

    // On considère l'item actif si l'URL commence par le href du menu (pour supporter les params/query)
    const normalize = (url: string) => url.split('?')[0].replace(/\/$/, '');
    const current = normalize(this.activePath || '');
    const activeIndex = this.groups.findIndex((group) =>
      group.items.some((item) => current.startsWith(normalize(item.href)))
    );

    if (activeIndex >= 0) {
      this.expandedIndex = activeIndex;
      return;
    }

    this.expandedIndex = this.groups.length > 0 ? 0 : -1;
  }
}
